export type ToggleButtonSize = 'md' | 'sm';
export type ToggleButtonActiveColor = 'default' | 'success' | 'primary';

export const TOGGLE_BUTTON_SIZE_CLASSES: Record<ToggleButtonSize, string> = {
  md: 'h-40 px-12',
  sm: 'h-36 px-12',
};

export const TOGGLE_BUTTON_ICON_ONLY_SIZE_CLASSES: Record<
  ToggleButtonSize,
  string
> = {
  md: 'h-40 px-10',
  sm: 'h-36 px-8',
};

export const TOGGLE_BUTTON_UNSELECTED_CLASSES =
  'cursor-pointer text-secondary-400 hover:bg-secondary-50 active:bg-secondary-100';

export const TOGGLE_BUTTON_SELECTED_CLASSES: Record<
  ToggleButtonActiveColor,
  string
> = {
  default:
    'cursor-default text-secondary-500 inset-ring-secondary-300 hover:bg-secondary-50 hover:inset-ring active:bg-secondary-100 active:inset-ring',
  success: 'cursor-default text-white',
  primary: 'cursor-default text-white',
};

export const TOGGLE_BUTTON_DISABLED_CLASSES =
  'cursor-not-allowed text-secondary-200';

export const TOGGLE_BUTTON_ACTIVE_BACKGROUND_CLASSES: Record<
  ToggleButtonActiveColor,
  string
> = {
  default: 'bg-white inset-ring inset-ring-secondary-300',
  success: 'bg-success-600',
  primary: 'bg-primary-600',
};

export const TOGGLE_BUTTON_DISABLED_ACTIVE_BACKGROUND_CLASSES =
  'bg-secondary-100';
